/**
 * @generated SignedSource<<16222b5dc8581bbfeedba978be1f8e3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GuildTypes = "GUILD" | "NETWORK" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type GuildPrimaryPhoto_guild$data = {
  readonly primaryPhoto: {
    readonly " $fragmentSpreads": FragmentRefs<"GraphQLImage_image">;
  } | null | undefined;
  readonly type: GuildTypes | null | undefined;
  readonly " $fragmentType": "GuildPrimaryPhoto_guild";
};
export type GuildPrimaryPhoto_guild$key = {
  readonly " $data"?: GuildPrimaryPhoto_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhoto_guild">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildPrimaryPhoto_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryPhoto",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GraphQLImage_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};

(node as any).hash = "61e2dd419521e1fae8ee50d5a3d9b200";

export default node;
